import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Grid, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import Header from "../../components/VerticalLayout/Header";
import Helpers from "../../helpers/helpers";
import { exportDoctorSales, getDoctorDetailsReport, getDoctorPaymentReport, resetReportActionState, resetReportState } from "../../store/actions";
import Label from "../../components/Common/Label";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomIconButton from "../../components/Form/CustomIconButton";
import AppTab from "../../components/Common/AppTab";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import DeleteModal from "../../components/Common/DeleteModal";
import CustomButton from "../../components/Form/CustomButton";
import ImportantNotice from "../../components/Common/ImportantNotice";
import AppDialog from "../../components/Common/AppDialog";
import CollapseTable from "../../components/Common/CollapseTable";
import moment from "moment";
import CustomSelect2 from "../../components/Form/CustomSelect2";

const SelloutReport = ({ title, reportDetails, salesListing, paymentListing, doctorSalesDocument, userPermission, leftSideBarType, width }) => {
    const { ID } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetReportState());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [tabValue, setTabValue] = useState('overview');
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const [page, setPage] = useState(1);
    const [length, setLength] = useState("10");
    const [timelinePage, setTimelinePage] = useState(1);
    const [timelineLength, setTimelineLength] = useState("10");
    const [markPaidOpen, setMarkPaidOpen] = useState(false);
    const [selectedCommission, setSelectedCommission] = useState(null);
    const [selectMonth, setSelectMonth] = useState(moment().format('MMMM'));
    const [selectedYear, setSelectedYear] = useState(moment().format('YYYY'));
    const [cancelOpen, setCancelOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const tabList = [
        { value: 'overview', label: 'Overview' },
        { value: 'payment_history', label: `Payment History` },
    ];

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-quotation") && setCreatable(true);
            userPermission?.includes("update-quotation") && setEditable(true);
            userPermission?.includes("export-quotation") && setExportable(true);
        }
    }, [userPermission])

    useEffect(() => {
        if (ID) {
            initData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ID, selectMonth, selectedYear]);

    useEffect(() => {
        if (ID) {
            initPaymentData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ID, page, length]);

    useEffect(() => {
        if (paymentListing?.data) {
            setIsLoading(false);
        }
    }, [paymentListing])

    useEffect(() => {
        if (reportDetails?.id) {
            setIsLoading(false);
        }
    }, [reportDetails])

    useEffect(() => {
        if (doctorSalesDocument?.code === 'success') {
            setIsLoading(false);
            Helpers.handleDownloadExcelFile(doctorSalesDocument?.file_base64, `doctor_sales`);
            dispatch(resetReportActionState());
        } else if (doctorSalesDocument?.code === 'error') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: doctorSalesDocument?.message || "Something went wrong, please try again later",
                type: "error",
            })
            dispatch(resetReportActionState());
        }
    }, [doctorSalesDocument])

    const initPaymentData = () => {
        setIsLoading(true);
        dispatch(getDoctorPaymentReport({ id: ID, length, page }));
    }

    const initData = () => {
        setIsLoading(true);
        dispatch(getDoctorDetailsReport({
            id: ID,
            month: selectMonth ? moment(selectMonth, "MMMM").format("M") : null,
            year: selectedYear
        }));

    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const handleCancelOrder = () => {

    }

    const handleExport = () => {
        setIsLoading(true);
        dispatch(exportDoctorSales({
            doctor_id: ID,
            month: selectMonth ? moment(selectMonth, "MMMM").format("M") : null,
            year: selectedYear
        }));
    }

    const handleMarkAsPaid = () => {

    }

    const actionItems = [
        { label: 'View doctor profile', iconName: 'mdi:eye-outline', color: '#594A4E', permission: true, onClick: () => navigate(`/doctor/${ID}`) },
        { label: 'Export', iconName: 'mdi:export-variant', color: '#594A4E', permission: true, onClick: () => handleExport() },
    ]

    const header = [
        {
            Header: "Month",
            accessor: (cellProps) => {
                return (cellProps?.month || "-")
            },
        },
        {
            Header: "Sales (RM)",
            accessor: (cellProps) => {
                return (cellProps?.total_order_amount || "-")
            },
        },
        {
            Header: "Commission (RM)",
            accessor: (cellProps) => {
                return (<div>{cellProps?.total_commissions || "-"}</div>)
            },
        },
        {
            Header: "Payment Status",
            accessor: (cellProps) => {
                const paymentStatus = [
                    { value: '0', label: "Unpaid", statusColor: 'red' },
                    { value: '1', label: "Paid", statusColor: 'green' },
                ]
                return (<Label.GeneralStatusLabel label={cellProps?.status || '0'} list={paymentStatus} marginLeft={"0px"} />)
            },
        },
        {
            Header: "Payment Date",
            accessor: (cellProps) => {
                return (<div>{cellProps?.paid_at || "-"}</div>)
            },
        },
        {
            Header: "Updated By",
            accessor: (cellProps) => {
                return (<div>{cellProps?.updated_by || "-"}</div>)
            },
        },
        {
            Header: " ",
            accessor: (cellProps) => {
                return (
                    cellProps?.status === '1' ? <div className="link-text" style={{ color: '#125FA9' }} onClick={() => navigate(`/order/${cellProps?.id}`)}>View details</div> :
                        <div className="link-text" style={{ color: '#D7114D' }} onClick={() => {setSelectedCommission(cellProps); setMarkPaidOpen(true)}}>Mark as paid</div>
                )
            },
        },
    ]

    const collapseHeader = [
        {
            Header: "Date",
            accessor: (cellProps) => {
                return (cellProps?.date || "-")
            },
        },
        {
            Header: "Active Customers",
            accessor: (cellProps) => {
                return (cellProps?.active_customers || "-")
            },
        },
        {
            Header: "Total Sales (RM)",
            accessor: (cellProps) => {
                return (<div>{cellProps?.total_sales || "-"}</div>)
            },
        },
        {
            Header: "Commission (RM)",
            accessor: (cellProps) => {
                return (<div>{cellProps?.total_commission || "-"}</div>)
            },
        },
    ]
    const collapseSubheader = [
        {
            Header: "Order ID",
            accessor: (cellProps) => {
                return (cellProps?.order_id || "-")
            },
        },
        {
            Header: "Customer",
            accessor: (cellProps) => {
                return (cellProps?.customer || "-")
            },
        },
        {
            Header: "Quantity",
            accessor: (cellProps) => {
                return (cellProps?.quantity || "-")
            },
        },
        {
            Header: "Amount (RM)",
            accessor: (cellProps) => {
                return (<div>{cellProps?.amount || "-"}</div>)
            },
        },
        {
            Header: "Commission (RM)",
            accessor: (cellProps) => {
                return (<div>{cellProps?.commission || "-"}</div>)
            },
        },
    ]

    const renderGeneralTab = () => {
        return (
            <>
                <Grid container spacing={2}>
                    <Grid item container sm={6} xs={12} spacing={1} mb={2}>
                        <Grid item xs={12} className="font-size-18 text-semibold ">{reportDetails?.name || '-'}</Grid>
                        <Grid item xs={12} className="d-flex align-items-center subheader-3">
                            {reportDetails?.state_name || '-'} <span className="mx-2">{'\u2022'}</span>
                            {reportDetails?.clinic_name || '-'} <span className="mx-2">{'\u2022'}</span>
                            {reportDetails?.speciality || '-'}
                        </Grid>
                    </Grid>
                    <Grid item sm={6} xs={12} mb={2} display={'flex'} direction={'row'} alignItems={'center'} gap={1} sx={{ justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'flex-end' } }}>
                        <CustomSelect2
                            values={selectMonth}
                            onChange={(e) => setSelectMonth(e)}
                            data={Helpers.getMonthList()?.map((month) => ({ label: month, value: month }))}
                            width={'auto'}
                        />
                        <CustomSelect2
                            values={selectedYear}
                            onChange={(e) => setSelectedYear(e)}
                            data={Helpers.getYearList()?.map((year) => ({ label: year, value: year }))}
                            width={'auto'}
                        />
                    </Grid>
                    {renderOtherInfo()}
                </Grid >
            </>
        )
    }

    const renderOtherInfo = () => {
        return (
            <Grid item xs={12} style={{ paddingTop: "10px" }}>
                <AppTab tabValue={tabValue} setTabValue={(e) => { setTabValue(e) }} tabList={tabList} indicatorColor={'#D7114D'} />
                {renderTabContent()}
            </Grid>
        )
    }

    const renderTabContent = () => {
        return (
            <>
                {
                    tabValue === 'overview' &&
                    <Grid container spacing={3} pb={2}>
                        <Grid item sm={6} xs={12} container spacing={2}>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center subheader-2">
                                <Icon icon={'mdi:stethoscope'} style={{ marginRight: 10 }} height={18} width={18} />Doctor
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center">
                                {reportDetails?.name || '-'}
                                {
                                    reportDetails?.id &&
                                    <CustomIconButton
                                        iconName={'mdi:open-in-new'}
                                        marginLeft={10}
                                        onClick={() => navigate(`/doctor/${reportDetails?.id}`)}
                                    />
                                }
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center subheader-2">
                                <Icon icon={'mdi:percent-outline'} style={{ marginRight: 10 }} height={18} width={18} />Commission Rate
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center">
                                {reportDetails?.commission_type === 'fixed' ? `RM ${reportDetails?.commission_rate || '0.00'}` : `${reportDetails?.commission_rate || '0'}%`}
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center subheader-2">
                                <Icon icon={'mdi:account-outline'} style={{ marginRight: 10 }} height={18} width={18} />Active Customers
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center">{reportDetails?.active_customers || '0'}</Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center subheader-2">
                                <Icon icon={'mdi:account-supervisor-outline'} style={{ marginRight: 10 }} height={18} width={18} />Total Customers
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center">{reportDetails?.all_customers || '0'}</Grid>
                        </Grid>

                        <Grid item sm={6} xs={12} container spacing={2}>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center subheader-2">
                                <Icon icon={'mdi:clipboard-check-outline'} style={{ marginRight: 10 }} height={18} width={18} />Completed Orders
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center">{reportDetails?.complete || 0}</Grid>

                            <Grid item sm={6} xs={6} className="d-flex align-items-center subheader-2">
                                <Icon icon={'mdi:invoice-text-outline'} style={{ marginRight: 10 }} height={18} width={18} />Total Sales
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center">{reportDetails?.total_sales || '0.00'}</Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center subheader-2">
                                <Icon icon={'mdi:wallet-bifold-outline'} style={{ marginRight: 10 }} height={18} width={18} />Commission Payable
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center">
                                RM {reportDetails?.payable || '0.00'}
                                <Label.GeneralStatusLabel label={reportDetails?.status} list={Helpers.paymentStatus} />
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center subheader-2">
                                <Icon icon={'mdi:invoice-text-outline'} style={{ marginRight: 10 }} height={18} width={18} />Payment Date
                            </Grid>
                            <Grid item sm={6} xs={6} className="d-flex align-items-center">{reportDetails?.payment_date || '-'}</Grid>
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <CollapseTable
                                header={collapseHeader}
                                subheader={collapseSubheader}
                                data={salesListing?.data || []} //dummyTableData
                                subDataName={'orders'}
                                customRowBorderTop={{ borderTop: '1px solid #594A4E' }}
                                customRow={[
                                    { value: ' ' },
                                    { value: 'Total' },
                                    { value: salesListing?.total?.total_active_customers || '0' },
                                    { value: `${salesListing?.total?.total_sales || 'RM 0.00'}` },
                                    { value: `${salesListing?.total?.total_commission || 'RM 0.00'}` }]}
                            />
                        </Grid>
                    </Grid>
                }
                {
                    tabValue === 'payment_history' &&
                    <>
                        <Table
                            header={header}
                            data={paymentListing?.data || []}
                            pageSize={length}
                            totalPage={paymentListing?.last_page || 1}
                            getLengthPage={getLengthPage}
                        />
                        <TablePageControl
                            from={paymentListing?.from || 0}
                            to={paymentListing?.to || 0}
                            total={paymentListing?.total || 0}
                            length={length}
                            setLength={setLength}
                            page={page}
                            setPage={setPage}
                            totalPage={paymentListing?.last_page || 1}
                        />
                    </>
                }
            </>
        )
    }

    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    < Stack gap={1} direction={'row'} className="d-flex">
                        {
                            reportDetails?.commission_payment_status === '0' &&
                            <CustomButton
                                title={'Mark as paid'}
                                press={() => setMarkPaidOpen(true)}
                                width={'80%'}
                            />
                        }
                        <RenderPopOverButton
                            items={actionItems}
                            iconName={'mdi:more-horiz'}
                            bordered={false}
                            height={48}
                            width={48}
                            backgroundColor={'#F9F9F9'}
                        />
                    </Stack>
                </div>

            }
            <div className="page-content" style={{ marginLeft: 768 < width && width <= 1024 && leftSideBarType === 'condensed' ? 70 : 0, paddingBottom: 100 }}>
                <LoadingDialog open={loading || !reportDetails?.id} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Header
                        breadcrumb={<Breadcrumbs
                            breadcrumbItems={[{ title: title, link: "/report" },
                            { title: reportDetails?.name || '-', link: "#" },
                            ]} />
                        }

                        children={
                            width > 425 &&
                            < Stack gap={1} direction={{ xs: "column", sm: "row" }} className="d-flex">
                                {
                                    reportDetails?.commission_payment_status === '0' &&
                                    <CustomButton
                                        title={'Mark as paid'}
                                        press={() => setMarkPaidOpen(true)}
                                    />
                                }
                                <RenderPopOverButton
                                    items={actionItems}
                                    iconName={'mdi:more-horiz'}
                                    bordered={false}
                                    height={48}
                                    width={48}
                                    backgroundColor={'#F9F9F9'}
                                />
                            </Stack>
                        } />
                    <Grid container spacing={2}>
                        <Grid item xs={12} pr={0} mr={0}>
                            <div className="px-2">{renderGeneralTab()}</div>
                        </Grid>
                    </Grid>
                </Container>
                <DeleteModal
                    open={cancelOpen}
                    close={() => setCancelOpen(false)}
                    title={`Cancel order?`}
                    verification={false}
                    submit={() => handleCancelOrder()}
                    message={
                        <>
                            <div className="mb-3">You are about to cancel this order.</div>
                            <div>
                                Cancelling this order will stop all processing, and the shipment will not be created or dispatched.
                            </div>
                        </>
                    }
                />
                <AppDialog
                    open={markPaidOpen}
                    close={() => setMarkPaidOpen(false)}
                    title={'Mark commission as paid'}
                    positiveTitle={'Mark as paid'}
                    positivePress={() => { handleMarkAsPaid() }}
                    cancelButton={true}
                    width={'40%'}
                >
                    <Grid container spacing={2}>
                        <Grid item sm={12}>You’re about to mark commission as paid for the selected doctors:</Grid>
                        <Grid item sm={8} className="subheader-2">Doctor</Grid>
                        <Grid item sm={4}>{reportDetails?.name || '-'}</Grid>
                        <Grid item sm={8} className="subheader-2">Commission Month</Grid>
                        <Grid item sm={4}>{selectedCommission?.month || '-'}</Grid>
                        <Grid item sm={8} className="subheader-2">Total Commission</Grid>
                        <Grid item sm={4}>{`RM ${selectedCommission?.total_commissions || '0.00'}`}</Grid>
                        <Grid item sm={12}>
                            <ImportantNotice
                                color={'#125FA9'}
                                backgroundColor={'#EFF7FF'}
                                textColor={'#594A4E'}
                                iconColor={'#125FA9'}
                                message={<>
                                    <div className="text-bold" style={{ color: '#0E172C' }}>Note:</div>
                                    Please confirm that all payments have been successfully processed before proceeding. This action will update the payment status and timestamp for each doctor. This action cannot be undone.
                                </>}
                            />
                        </Grid>
                    </Grid>
                </AppDialog>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ General, Login, Layout, Report }) {
    console.log("Report", Report)
    return {
        leftSideBarType: Layout.leftSideBarType,
        width: Layout.currentWidth,
        reportDetails: Report?.doctorReportDetails?.data,
        paymentListing: Report?.doctorPaymentReportDetails?.data,
        salesListing: Report?.doctorReportDetails?.table,
        doctorSalesDocument: Report?.exportDoctorSales,
        userData: Login?.verifyAdmin?.user?.data,
        userPermission: Login?.permissionArry,
        sentEmail: General?.send_email_response,
    };
}

export default connect(mapStateToProps)(SelloutReport);
